var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.loading.completed)?_c('div',{attrs:{"id":"footer"}},[_c('p',[_vm._v("resn 2020")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }